export const getTokenHolders = (
  dispatch: any,
  token: string,
  tokenSupply: number,
  start: number,
  limit: number
) =>
  dispatch({
    type: "GET_TOKENHOLDERS",
    token,
    tokenSupply,
    start,
    limit,
  });

export const getTokenHoldersSuccess = (
  data: any,
  total: number,
  rangeTotal: number
) => ({
  type: "GET_TOKENHOLDERS_SUCCESS",
  data,
  total,
  rangeTotal,
});

export const getTokenHoldersFailure = (error: Error) => ({
  type: "GET_TOKENHOLDERS_FAILURE",
  error,
});

export const getDistribution = (
  dispatch: any,
  token: string,
  tokenSupply: number
) =>
  dispatch({
    type: "GET_DISTRIBUTION",
    token,
    tokenSupply,
  });

export const getDistributionSuccess = (distribution: any) => ({
  type: "GET_DISTRIBUTION_SUCCESS",
  distribution,
});

export const getDistributionFailure = (error: Error) => ({
  type: "GET_DISTRIBUTION_FAILURE",
  error,
});
